import { Card, Group, Text } from '@mantine/core'
import { IconType } from 'react-icons'
import { TbExternalLink } from 'react-icons/tb'
import styles from './StatCard.module.css'

interface StatCardProps {
  icon: IconType
  iconColor: string
  text: string
  link: string
  useGradient?: boolean
}

export function StatCard({ icon: Icon, iconColor, text, link, useGradient = false }: StatCardProps) {
  const iconStyle = useGradient ? { fill: 'url(#grafana-gradient)' } : { color: iconColor }

  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      className={styles.hoverableCard}
      onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
    >
      {useGradient && (
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <defs>
            <linearGradient id="grafana-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop stopColor="#ff6b35" offset="0%" />
              <stop stopColor="#ff8c42" offset="50%" />
              <stop stopColor="#ffa726" offset="100%" />
            </linearGradient>
          </defs>
        </svg>
      )}

      <Group align="center">
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <defs>
            <linearGradient id="grafana-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop stopColor="#ff6b35" offset="0%" />
              <stop stopColor="#ff8c42" offset="50%" />
              <stop stopColor="#ffa726" offset="100%" />
            </linearGradient>
          </defs>
        </svg>
        <Icon size={24} style={iconStyle} />
        <Text size="md" pt={4}>
          {text} {'  '}
          <TbExternalLink size={12} />
        </Text>
      </Group>
    </Card>
  )
}
